import axios from "axios";
import { BASE_ENDPOINT } from "../helpers/Config";

const SWAP_HISTORY_URL = `${BASE_ENDPOINT}/admin/swap-history`;

/**
 * POST /admin/swap-history
 * @param {{ token: string, page_no?: number, limit?: number }} params
 */
export async function fetchSwapHistory(params) {
    const res = await axios({
        method: "post",
        url: SWAP_HISTORY_URL,
        headers: { "Content-Type": "application/json" },
        data: {
            token: params.token,
            page_no: params.page_no ?? 1,
            limit: Math.min(100, Math.max(1, params.limit ?? 20)),
        },
    });
    return res?.data;
}
